import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import CaseStamp from "./CaseStamp";
import VideoPlayerModal from "./VideoPlayerModal";

const ClipboardEvidenceModal = ({ detail, onClose }) => {
  const closeRef = useRef(null);
  const [video, setVideo] = useState(null);

  useEffect(() => {
    setVideo(null);
    if (!detail) return;
    closeRef.current?.focus();
  }, [detail]);

  if (!detail) return null;

  return createPortal(
    <div className="clipboard-modal-backdrop" onClick={onClose} role="presentation">
      <div
        className="clipboard-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="clipboard-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="clipboard-modal-board">
          <div className="clipboard-modal-clip" aria-hidden="true" />
          <article className="clipboard-modal-sheet">
            <header className="clipboard-modal-head">
              <div>
                <p className="clipboard-modal-file">{detail.fileNo}</p>
                <h2 id="clipboard-modal-title">{detail.title}</h2>
                {detail.subtitle ? <p className="clipboard-modal-subtitle">{detail.subtitle}</p> : null}
              </div>
              <button ref={closeRef} type="button" className="clipboard-modal-close" onClick={onClose}>
                Close
              </button>
            </header>

            {detail.image ? (
              <div className="clipboard-modal-media">
                <img src={detail.image} alt={detail.imageAlt || detail.title} />
              </div>
            ) : null}

            {detail.summary ? <p className="clipboard-modal-summary">{detail.summary}</p> : null}
            {detail.body ? <p className="clipboard-modal-body">{detail.body}</p> : null}

            {detail.meta?.length ? (
              <dl className="clipboard-modal-meta">
                {detail.meta.map((row) => (
                  <div key={`${row.label}-${row.value}`}>
                    <dt>{row.label}</dt>
                    <dd>{row.value}</dd>
                  </div>
                ))}
              </dl>
            ) : null}

            {detail.bullets?.length ? (
              <div className="clipboard-modal-notes">
                <p className="clipboard-modal-notes-label">Investigator notes</p>
                <ul>
                  {detail.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              </div>
            ) : null}

            {detail.stack?.length ? (
              <p className="clipboard-modal-stack">
                <span>Stack</span> {detail.stack.join(" · ")}
              </p>
            ) : null}

            {detail.links?.length || detail.videos?.length ? (
              <div className="clipboard-modal-links">
                {detail.videos?.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    className="clipboard-modal-link clipboard-modal-link--video"
                    onClick={() => setVideo(item)}
                  >
                    ▶ Watch video
                  </button>
                ))}
                {detail.links?.map((link) =>
                  link.internal ? (
                    <Link key={link.href} to={link.href} className="clipboard-modal-link" onClick={onClose}>
                      {link.label} ↗
                    </Link>
                  ) : (
                    <a
                      key={link.href}
                      href={link.href}
                      className="clipboard-modal-link"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {link.label} ↗
                    </a>
                  )
                )}
              </div>
            ) : null}

            {detail.stamp ? (
              <CaseStamp tone="red" rotate={-8} className="clipboard-modal-stamp">
                {detail.stamp}
              </CaseStamp>
            ) : null}
          </article>
        </div>
      </div>
      <VideoPlayerModal video={video} onClose={() => setVideo(null)} />
    </div>,
    document.body
  );
};

export default ClipboardEvidenceModal;
